import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AdminPortalModal from './AdminPortalModal';
import { connect } from 'react-redux';
import DAO from '../dao/DAO';
import { LoadingWrapper } from 'react-fast-ui';
import ActivationTable from './table/ActivationTable';


class ViewActivationModal extends Component {

  static contextTypes = {
    dao: PropTypes.instanceOf(DAO),
    onError: PropTypes.func,
    onSuccess: PropTypes.func,
  };

  static propTypes = {
    open: PropTypes.bool,
    accentColor: PropTypes.string,
    onClose: PropTypes.func
  }

  state = {
    firstTime: true,
    fastDrawActivations: [],
    fastDrawTabletActivations: [],
    fsClassicActivations: [],
    fastScoutClassic: [],
    fastDraw: [],
    fastDrawTablet: [],
    loadingFastDraw: (null: ?Promise),
    loadingFastDrawTablet: (null: ?Promise),
    loadingFSClassic: (null: ?Promise),
    hasFastDraw: false,
    hasFastDrawTablet: false,
    hasFSClassic: false
  }

  componentWillReceiveProps(nextProps: Readonly<P>, nextContext: any) {
    const { open, licensedProducts } = this.props;
    if (nextProps.open && !open) {
      const fastDraw = licensedProducts.filter((item) => item.product.displayName === 'FastDraw');
      const fastDrawTablet = licensedProducts.filter((item) => item.product.displayName === 'FastDrawTablet');
      const fastScoutClassic = licensedProducts.filter((item) => item.product.displayName === 'FastScout Classic');
      this.setState({ fastDraw, fastScoutClassic, fastDrawTablet, firstTime: false }, this.updateSeatTables);
    }
  }

  updateSeatTables() {
    const { fastDraw, fastDrawTablet, fastScoutClassic } = this.state;
    if (fastDraw && fastDraw.length > 0) {
      this.setState({ hasFastDraw: true });
      this.getFastDrawSeatActivations(fastDraw[ 0 ]);
    }
    if (fastDrawTablet && fastDrawTablet.length > 0) {
      this.setState({ hasFastDrawTablet: true });
      this.getFastDrawTabletSeatActivations(fastDrawTablet[ 0 ]);
    }
    if (fastScoutClassic && fastScoutClassic.length > 0) {
      this.setState({ hasFSClassic: true });
      this.getFastScoutClassicSeatActivations(fastScoutClassic[ 0 ]);
    }
  }

  getFastDrawSeatActivations(fastDraw) {
    const { loadingFastDraw: pendingPromise } = this.state;
    const { dao } = this.context;
    if (pendingPromise) {
      pendingPromise.cancel();
    }
    const loadingFastDraw = dao.licensedProducts.fetchSeatActivations({
      licensedProductId: fastDraw.id
    })
      .then((fastDrawActivations) => {
        this.setState({ fastDrawActivations, loadingFastDraw: null });
      });

    this.setState({ loadingFastDraw });
  }

  getFastDrawTabletSeatActivations(fastDrawTablet) {
    if (pendingPromise) {
      pendingPromise.cancel();
    }
    const { loadingFastDrawTablet: pendingPromise } = this.state;
    const { dao } = this.context;
    const loadingFastDrawTablet = dao.licensedProducts.fetchSeatActivations({
      licensedProductId: fastDrawTablet.id
    }).then((fastDrawTabletActivations) => {
      this.setState({ fastDrawTabletActivations, loadingFastDrawTablet: null });
    });

    this.setState({ loadingFastDrawTablet });
  }

  getFastScoutClassicSeatActivations(fastScoutClassic) {
    const { dao } = this.context;
    const { loadingFSClassic: pendingPromise } = this.state;
    if (pendingPromise) {
      pendingPromise.cancel();
    }
    const loadingFSClassic = dao.licensedProducts.fetchSeatActivations({
      licensedProductId: fastScoutClassic.id
    })
      .then((fsClassicActivations) => {
        this.setState({ fsClassicActivations, loadingFSClassic: null });
      });

    this.setState({ loadingFSClassic });
  }

  revokeActivation = (id) => {
    const { dao, onSuccess, onError } = this.context;
    dao.licensedProducts.deleteSeatActivations(id)
      .then(() => {
        onSuccess('User Seat Revoked');
        this.updateSeatTables();
      })
      .catch(onError);
  }

  render() {
    const { open, accentColor, onClose } = this.props;
    const {
      fsClassicActivations, loadingFSClassic, loadingFastDraw, loadingFastDrawTablet, fastDrawActivations,
      hasFastDraw, hasFastDrawTablet, hasFSClassic, fastDrawTabletActivations
    } = this.state;

    return (
      <AdminPortalModal
        open={open}
        onClose={onClose}
        accentColor={accentColor}
        showPrimaryButton={false}
        size='lg'
        secondaryStyle={{ justifyContent: 'flex-end' }}
        style={{ zIndex: 80 }}
        title={'ACTIVATIONS'}
      >
        <div>
          {hasFSClassic &&
          <div style={{ marginTop: 15 }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              borderBottom: `1px solid ${accentColor}`,
              paddingBottom: 4,
              marginBottom: 4,
            }}><h2 style={{ fontSize: 18 }} className='futura-pt-bold'>FASTSCOUT CLASSIC</h2></div>
            <LoadingWrapper loading={Boolean(loadingFSClassic)}>
              <ActivationTable
                activations={fsClassicActivations}
                onRevoke={this.revokeActivation}
                accentColor={accentColor}/>
            </LoadingWrapper>
          </div>
          }
          {hasFastDraw &&
          <div style={{ marginTop: 15 }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              borderBottom: `1px solid ${accentColor}`,
              paddingBottom: 4,
              marginBottom: 4,
            }}>
              <h2 style={{ fontSize: 18 }} className='futura-pt-bold'>FASTDRAW</h2>
            </div>
            <LoadingWrapper loading={Boolean(loadingFastDraw)}>
              <ActivationTable
                activations={fastDrawActivations}
                onRevoke={this.revokeActivation}
                accentColor={accentColor}/>
            </LoadingWrapper>
          </div>
          }
          {hasFastDrawTablet &&
          <div style={{ marginTop: 15 }}>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              borderBottom: `1px solid ${accentColor}`,
              paddingBottom: 4,
              marginBottom: 4,
            }}>
              <h2 style={{ fontSize: 18 }} className='futura-pt-bold'>FASTDRAWTABLET</h2>
            </div>
            <LoadingWrapper loading={Boolean(loadingFastDrawTablet)}>
              <ActivationTable
                activations={fastDrawTabletActivations}
                onRevoke={this.revokeActivation}
                accentColor={accentColor}/>
            </LoadingWrapper>
          </div>
          }
        </div>
      </AdminPortalModal>
    );
  }
}

export default connect()(ViewActivationModal);